import { ObjectHelper } from "@bryntum/schedulerpro";

const HasAssignedToMixin = (target) => class extends target {
  static get fields() {
    return [
      { name: "assignedBoardUsers", dataSource: "assigned_boardusers", defaultValue: [] }
    ]
  }

  set assignedBoardUsers(value) {
    // There is an issue where there is a maximum call stack error occurred in a situation where a last resource assignment gets removed
    // from assigned to field, causing the assignedBoardUsers assign an empty array which trigger the input change again and which again then assign
    // an empty array cause this loop to continue until break. Assuming always get different reference for an empty array.
    // alternatively, removing type "array" from assignedBoardUsers field fix the error
    if (!ObjectHelper.isEqual(value, this.get("assignedBoardUsers"))) {
      this.set("assignedBoardUsers", value);
    }
  }

  get assignedBoardUsers() {
    return this.get("assignedBoardUsers");
  }

  get _assignedBoardUsers() {
    const assignedBoardUserIds = this.get("assignedBoardUsers");
    if (assignedBoardUserIds.length) {
      const boardUsersStore = this.project.boardUsersStore;
      return assignedBoardUserIds.map((id) => boardUsersStore.getById(id))
    }
    return [];
  }

  get assignedBoardUserValues() {
    if (this.project) {
      return this._assignedBoardUsers.map((boardUser) => boardUser.name);
    }
    return null;
  }
}

export default HasAssignedToMixin;
